<div >
    <app-breadcrumb
            [firstNode]="{label: 'Users list', 'url': '/home'}">
    </app-breadcrumb>
    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="row">
                    <div class="card--box__header--info">
                        <div *ngIf="clinicName != null && clinicCity != null" class="card--box__header__title">
                            <h6>{{ 'Translations' | translate }}</h6>
                        </div>
                        <div *ngIf="clinicName == null && clinicCity == null" class="card--box__header__title">
                            <h2>{{ 'Translations Management' | translate }}</h2>
                        </div>
                    </div>
                    <div class="card--box__header--action text-xs-right">

                    </div>
                </div>
            </div>
            <div class="card-block card--box__block">
                <div class="row">
                    <div class="col-xs-6">
                        <div class="sprite card--box__search card--box__search--search">
                            <!--user search custom results-->
                            <ng-template #searchList let-model="item" let-index="index">
                                {{ model.surname + ' ' + model.given_name }}
                            </ng-template>
                            <input [(ngModel)]="searchInfo.keyword"
                                class="card--box__search__input"
                                placeholder="{{ 'Search by translation' | translate }}" (keyup.enter)="searchItems()"/>
                        </div>
                    </div>
                    <div class="col-xs-4 hidden">
                        <select class="form-control" name="component" [(ngModel)]="searchInfo['component']"
                                (change)="setFilter($event, 'component')">
                            <option value="0" selected>{{'Filter by component' | translate }}</option>
                            <option *ngFor="let component of components" [value]="component['name']">{{ component['name'] | translate }}
                            </option>
                        </select>
                    </div>
                    <div class="col-xs-2">
                        <button type="button"
                            class="btn btn-primary btn-block" (click)="exportTranslation()">
                            <i class="fas fa-sync-alt"></i>
                            {{ 'Export file' | translate }}
                        </button>
                    </div>
                    <div class="col-xs-2">
                        <input id="imageUpload" type="file" (change)="importTranslation($event)" class="fileInputProfile hidden" #inputFile/>
                        <label for="imageUpload" class="btn btn-primary btn-upload btn-block">{{ 'Import file' | translate }}</label>
                    </div>
                    <div class="col-xs-2">
                        <button type="button" (click)="createTranslation()"
                                class="btn btn-primary btn-block ">
                            <i class="fas fa-sync-alt"></i>
                            {{ 'Create Translation File' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table--grid">
            <div class="table--grid__body">
                <div class="row">
                    <!--table headers-->
                    <div class="col-xs-11 col-lg-11">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}" class="{{ column[2] }}"
                                (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!--table cells-->
                <div *ngFor="let item of items" class="row">
                    <div class="col-xs-11 col-lg-11">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}">
                                <span *ngIf="column[0] === 'component'">{{ item[column[0]] | translate}}</span>
                                <span *ngIf="column[0] !== 'component'">{{ item[column[0]]}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-1 col-lg-1 table--grid__actions table--grid__actions--hover">
                        <div class="btn-group dropdown" dropdown>
                            <button class="btn btn-link table--grid__actions__ellipsis dropdown-toggle" dropdownToggle>
                                <i class="fas fa-ellipsis-h table--grid__actions__ellipsis__icon" aria-hidden="true"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right table--grid__actions__links">
                                <li class="dropdown-item"
                                    (click)="openFormModal({ action: 'update', id: item['id'], title: 'Edit Translation', url: 'translations' });">
                                    <a class="btn btn-link table--grid__action-btn">
                                        <i class="fas fa-pencil-alt table--grid__actions__links__icon" aria-hidden="true"
                                        title="{{ 'Edit' | translate }}"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--pagination-->
    <pagination-component *ngIf="!paginationHidden" [(page)]="currentPage" [total]="totalItems" [perPage]="itemsPerPage"
                          [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)"
                          #pagination></pagination-component>
    <!-- Modal -->
    <div bsModal #modal="bs-modal" class="modal fade"
         [ngClass]="params['action'] === 'activate' || params['action'] === 'delete' ? 'modal-confirmation': ''"
         tabindex="-1" role="dialog" aria-hidden="true">
        <div *ngIf="params['component'] == null && params['action'] !== 'activate' && params['action'] !== 'delete'"
             class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{ params['title'] | translate }}</h4>
                </div>
                <div class="modal-body">
                    <button type="button" class="btn btn-link close" (click)="hideModal()" aria-label="Close">
                    </button>
                    <div *ngIf="params['action'] === 'read' && ((authService.user['role_id'] === 1 && (params['role-id'] === '1' || params['role-id'] === '2')) || (authService.user['role_id'] === 2 && params['role-id'] > '1' && params['role-id'] <= '4'))">
                        <ul class="list-inline">
                            <li class="list-inline-item" *ngIf="isUpdatable">
                                <button class="btn btn-link">
                                    <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                                    <span>{{ 'Edit' | translate }}</span>
                                </button>
                            </li>
                        </ul>
                        <hr/>
                    </div>
                    <ng-template [ngIf]="!formLoading">
                        <form [formGroup]="form" novalidate (ngSubmit)="submit(form.value, form.valid)" class="mat-form">
                            <div *ngIf="errorMessage.length > 0" class="row form-group" role="alert">
                                <div class="col-md-10">
                                    <div class="alert alert-danger">
                                        <div *ngFor="let error of errorMessage">
                                            <i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{ error |
                                            translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row form-group hidden">
                                <div class="form-group col-xs-12">
                                    <label>{{ 'Component' | translate }} *</label>
                                    <select name="component" formControlName="component">
                                        <option disabled selected value=0>{{ 'Select Component' | translate}}
                                        </option>
                                        <option *ngFor="let component of components" [value]="component['name']">{{component['name'] | translate }}
                                        </option>
                                    </select>
                                    <input type="text" class="hidden-xs-up" formControlName="component">

                                    <small class="form-text text-danger"
                                           [hidden]="form.controls.component.valid || ((form.controls.component.pristine && !formSubmitted) || form.controls.component.disabled)">
                                    </small>
                                </div>
                            </div>
                            <div class="row form-group hidden">
                                <div class="form-group col-xs-12">
                                    <mat-form-field class="ps-content">
                                        <textarea type="text" matInput [placeholder]="'Label' | translate" formControlName="text" readonly></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="form-group col-xs-12" #englishFG>
                                    <mat-form-field class="ps-content">
                                        <textarea type="text" matInput [placeholder]="'English' | translate" formControlName="en_GB" (focus)="onInputFocused($event, englishFG, className, true)"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="form-group col-xs-12" #germanFG>
                                    <mat-form-field class="ps-content">
                                        <textarea type="text" matInput [placeholder]="'German' | translate" formControlName="de_CH" (focus)="onInputFocused($event, germanFG, className, true)"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="form-group col-xs-12" #frenchFG>
                                    <mat-form-field class="ps-content">
                                        <textarea type="text" matInput [placeholder]="'French' | translate" formControlName="fr_FR" (focus)="onInputFocused($event, frenchFG, className, true)"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-xs-12" #italianFG>
                                    <mat-form-field class="ps-content">
                                        <textarea type="text" matInput [placeholder]="'Italian' | translate" formControlName="it_IT" (focus)="onInputFocused($event, italianFG, className, true)"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div *ngIf="params['action'] !== 'read'" class="row">
                                <div class="col-xs-12 text-xs-right">
                                    <button type="button" class="btn btn-secondary" (click)="hideModal()">
                                        {{ 'Cancel' | translate }}
                                    </button>
                                    <button type="submit" class="btn btn-primary">
                                        {{ 'Submit' | translate }}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>
<dialog-component #dialog></dialog-component>

